import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/opf.jpg"

const Opf = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - OP  Freigabe</h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Sollten Sie vor einer Operation stehen, ist eine internistische Untersuchung , um das zu erwartende Risiko für den Gesamtorganismus rechtzeitig zu erheben, notwendig.
                        <br/><br/>
                        Bringen Sie bitte alle benötigten Befunde schon mit (Laborwerte , Vorbefunde, Entlassungsbriefe etc.)
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Opf;